import { render, staticRenderFns } from "./vodBaseUpload.vue?vue&type=template&id=25ae7fac&scoped=true"
import script from "./vodBaseUpload.vue?vue&type=script&lang=js"
export * from "./vodBaseUpload.vue?vue&type=script&lang=js"
import style0 from "./vodBaseUpload.vue?vue&type=style&index=0&id=25ae7fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae7fac",
  null
  
)

export default component.exports